import React from 'react'
import {
    ReloadOutlined,
} from "@ant-design/icons"
import {updateDailyRates} from './ExchangeRateFuncs'
import {DefaultProps, RefTable, Validator} from "./RefTable";


export const DailyExchangeRates = (props)=><RefTable {...props}/>;



DailyExchangeRates.defaultProps = {
    ...DefaultProps,
    tableName: "daily_exchange_rates",
    tableSchema: "daily_exchange_rates",
    edit: true,
    title: "Daily Exchange Rates",
    theadHeight: 40,
    validator: {
        daily_rate: new Validator("daily_rate", async (value)=> {
            if(value <= 0 )
                return Promise.reject("Exchange rate cannot be zero or negative")
        })
    },
    actions: [
        {
            event: "sync",
            title: "Sync",
            icon: <ReloadOutlined/>
        }
    ],
    onEvent: async (e)=>{
        if(e === "sync")
            await updateDailyRates()
    },
}
